import { fromFetch } from 'rxjs/fetch';
import { userProfileGetFavorites } from 'constants/routes';

export default fromFetch(userProfileGetFavorites, {
  headers: {
    'Content-Type': 'application/json',
    // disabling cache to always get the latest favorites
    'Cache-Control': 'no-cache',
    'Accept': 'application/json',
  },
});
